import { systemTypeKeyMap, wrapFieldValue } from './widgets';

export const unSortableList = [];

export const getWidgetType = (field) => {
  const { fieldType, customField } = field;
  if (fieldType !== 'custom') {
    const key = systemTypeKeyMap[fieldType] || fieldType;
    if (['name', 'scene', 'question', 'goal'].includes(key)) {
      return 'text';
    } else if (['description'].includes(key)) {
      return 'textarea';
    } else if (['priority'].includes(key)) {
      return 'select';
    } else if (['progress'].includes(key)) {
      return 'progress';
    }
    return '';
  }
  return customField?.widgetType || '';
};

export const parseDefaultValue = (fieldConfigs) => {
  const customFields = [];
  const requirement = { customFields };
  fieldConfigs.forEach((field) => {
    const { fieldType, defaultValue, customField } = field;
    if (!defaultValue) {
      return;
    }
    const widgetType = getWidgetType(field);
    if (fieldType !== 'custom') {
      const value = wrapFieldValue(defaultValue, widgetType);
      const key = systemTypeKeyMap[fieldType] || fieldType;
      requirement[key] = value;
    } else if (customField) {
      customFields.push({ type: widgetType, customFieldId: customField?.id, value: defaultValue });
    }
  });
  return requirement;
};
